import types from "./types";

const INITIAL_STATE = {
	externalAudit: null,
	externalAuditError: null,
	externalAuditLoading: false,

	//create
	createexternalAudit: null,
	createexternalAuditError: null,
	createexternalAuditLoading: false,

	//update
	updateexternalAudit: null,
	updateexternalAuditError: null,
	updateexternalAuditLoading: false,

	//delete
	deleteexternalAudit: null,
	deleteexternalAuditError: null,
	deleteexternalAuditLoading: false,

	//single item

	singleItem: null,
};

const ExternalAuditReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case types.GET_EXTERNAL_AUDIT_START:
			return {
				...state,
				externalAudit: null,
				externalAuditError: null,
				externalAuditLoading: true,
			};
		case types.GET_EXTERNAL_AUDIT_SUCCESS:
			return {
				...state,
				externalAudit: action.payload,
				externalAuditLoading: false,
			};
		case types.GET_EXTERNAL_AUDIT_ERROR:
			return {
				...state,
				externalAuditError: action.payload,
				externalAuditLoading: false,
			};
		case types.GET_EXTERNAL_AUDIT_RESET:
			return {
				...state,
				externalAuditError: null,
				externalAuditLoading: false,
			};
		//create

		case types.CREATE_EXTERNAL_AUDIT_START:
			return {
				...state,
				createexternalAudit: null,
				createexternalAuditError: null,
				createexternalAuditLoading: true,
			};
		case types.CREATE_EXTERNAL_AUDIT_SUCCESS:
			return {
				...state,
				createexternalAudit: action.payload,
				createexternalAuditLoading: false,
			};
		case types.CREATE_EXTERNAL_AUDIT_ERROR:
			return {
				...state,
				createexternalAuditError: action.payload,
				createexternalAuditLoading: false,
			};
		case types.CREATE_EXTERNAL_AUDIT_RESET:
			return {
				...state,
				createexternalAuditError: null,
				createexternalAuditLoading: false,
			};
		//delete

		case types.DELETE_EXTERNAL_AUDIT_START:
			return {
				...state,
				deleteexternalAudit: null,
				deleteexternalAuditError: null,
				deleteexternalAuditLoading: true,
			};
		case types.DELETE_EXTERNAL_AUDIT_SUCCESS:
			return {
				...state,
				deleteexternalAudit: action.payload,
				deleteexternalAuditLoading: false,
			};
		case types.DELETE_EXTERNAL_AUDIT_ERROR:
			return {
				...state,
				deleteexternalAuditError: action.payload,
				deleteexternalAuditLoading: false,
			};
		case types.DELETE_EXTERNAL_AUDIT_RESET:
			return {
				...state,
				deleteexternalAudit: null,
				deleteexternalAuditError: null,
				deleteexternalAuditLoading: false,
			};

		//update
		case types.UPDATE_EXTERNAL_AUDIT_START:
			return {
				...state,
				updateexternalAudit: null,
				updateexternalAuditError: null,
				updateexternalAuditLoading: true,
			};
		case types.UPDATE_EXTERNAL_AUDIT_SUCCESS:
			return {
				...state,
				updateexternalAudit: action.payload,
				updateexternalAuditLoading: false,
			};
		case types.UPDATE_EXTERNAL_AUDIT_ERROR:
			return {
				...state,
				updateexternalAuditError: action.payload,
				updateexternalAuditLoading: false,
			};
		case types.UPDATE_EXTERNAL_AUDIT_RESET:
			return {
				...state,
				updateexternalAudit: null,
				updateexternalAuditError: null,
				updateexternalAuditLoading: false,
			};

		default:
			return { ...state };
	}
};

export default ExternalAuditReducer;
